/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useRef } from "react";
import Form from "../ui/form/Form";
import Button from "../ui/Button";
import FormError from "../ui/form/FormError";
import usePluginUtils from "../../hooks/usePluginUtils";
import { useRequiredFieldsCompletion } from "../../hooks/useRequiredFieldsCompletion";
import FormFieldsWrapper from "../ui/form/FormFieldsWrapper";
import ClientTermsCheckboxes from "./form/ClientTermsCheckboxes";
import GuestClientFields from "./form/GuestClientFields";
import CaptchaWidget from "./CaptchaWidget";
import { useCaptcha } from "../../hooks/useCaptcha";

const DetailsForm = ({ form, terms, onSubmit, submitTitle, isSubmitting, withCaptcha }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = form;
  const { isPluginEnabled } = usePluginUtils();
  const { isComplete } = useRequiredFieldsCompletion({ form });
  const { challengeData, isReady, refreshChallenge } = useCaptcha();
  const captchaRef = useRef(null);

  const wrappedOnSubmit = async (data) => {
    const captchaToken = (withCaptcha && captchaRef.current) ? await captchaRef.current.getToken() : null;
    onSubmit(data, captchaToken, refreshChallenge);
  };

  return (
    <Form onSubmit={handleSubmit(wrappedOnSubmit)} noValidate>
      <FormFieldsWrapper>
        {!isPluginEnabled("client_login") && (
          <GuestClientFields control={control} errors={errors} />
        )}
        <ClientTermsCheckboxes form={form} terms={terms} />
      </FormFieldsWrapper>
      {withCaptcha && challengeData && isReady && (
        <CaptchaWidget ref={captchaRef} challenge={challengeData} />
      )}
      <Button
        variant="primary"
        title={submitTitle}
        loading={isSubmitting}
        disabled={!isComplete}
      />
      {errors.root && <FormError>{errors.root.message}</FormError>}
    </Form>
  );
};

export default DetailsForm;
